export const state = () => ({
  // New Format
  name: null,
  data: null
})

export const mutations = {
  show (state, { name, data }) {
    state.name = name
    state.data = {
      ...state.data,
      ...data
    }
  },
  hide (state, name) {
    if (name) {
      if (state.name === name) {
        state.name = null
        state.data = {}
      }
    } else {
      state.name = null
      state.data = {}
    }
  }
}

export const actions = {
  show ({ commit }, params) {
    commit('hide')
    commit('show', params)
  }
}
